import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { injectIntl, FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import { Button, EButtonType } from '@repo/apg-ui';
import './Header.scss';
import { getUserEmail, isAuthenticated, login, logout } from '../../utils/keycloak';
import { getHomeHref } from '../../utils/homeLink';
import { ReactComponent as Logo } from '../../assets/imgs/logo.svg';
import { ReactComponent as AccountIcon } from '../../assets/icons/account.svg';
import bsStyles from '../../styles/bs.module.scss';
import LanguageSwitcher from './LanguageSwitcher';
import UserMenu from './UserMenu';
import BurgerMenu from './BurgerMenu';

interface Props {
  intl: any;
}

const Header = ({ intl }: Props) => {
  const [language, setLanguage] = useState(sessionStorage.getItem('apg_easy_debug_language') || 'de');
  const location = useLocation();

  if (process.env.REACT_APP_MODE === 'django') {
    return null;
  }

  const handleLanguageChange = (newLang) => {
    sessionStorage.setItem('apg_easy_debug_language', newLang);
    setLanguage(newLang);
    window.location.reload();
  };

  const burgerMenuItems = [
    {
      key: 'dashboard',
      label: <FormattedMessage id='ec.components.buttons.dashboard' defaultMessage='Dashboard' />,
      active: location.pathname.startsWith('/dashboard'),
      onClick: () => {
        if (isAuthenticated()) {
          window.location.href = '/dashboard';
        } else {
          login();
        }
      },
    },
    {
      key: 'easy',
      label: <FormattedMessage id='ec.components.buttons.easy' defaultMessage='Online buchen' />,
      active: location.pathname.startsWith('/journey2'),
      onClick: () => {
        window.location.href = '/journey2/1';
      },
    },
  ];

  return (
    <div className={classNames('headerContainer', bsStyles.bootstrap)}>
      <a className='logo' href={getHomeHref(intl)} aria-label='APG | SGA Out of Home Media'>
        <Logo aria-hidden='true' focusable='false' />
      </a>
      <div className='button-bread-crumbs'>
        <LanguageSwitcher language={language} onLanguageChange={handleLanguageChange} />
        {isAuthenticated() ? (
          <UserMenu email={getUserEmail()} onLogout={logout} />
        ) : (
          <Button
            className='ms-auto my-auto'
            onClick={() => {
              login();
            }}
            buttonType={EButtonType.InvertedPillMedium}
          >
            <AccountIcon className='account-icon' />
            <FormattedMessage id='ec.components.buttons.login' defaultMessage='Login' />
          </Button>
        )}
        <BurgerMenu items={burgerMenuItems} />
      </div>
    </div>
  );
};

export default injectIntl(Header);
